export class DistanceCalculatorService {
    constructor() {}

    calculateDistanceFromCurrentLocation(
        workspaceLat: number,
        workspaceLon: number
    ): Promise<{ success: boolean; distance: number }> {
        return new Promise((resolve) => {
            this.getUserLocation()
                .then(({ userLat, userLon }) => {
                    const distance = this.calculateDistance(
                        workspaceLat,
                        workspaceLon,
                        userLat,
                        userLon
                    );
                    resolve({ success: true, distance });
                })
                .catch(() => {
                    resolve({ success: false, distance: 0 });
                });
        });
    }

    requestUserLocation(): Promise<{ userLat: number; userLon: number }> {
        return this.getUserLocation();
    }

    private getUserLocation(): Promise<{ userLat: number; userLon: number }> {
        return new Promise((resolve, reject) => {
            if ('geolocation' in navigator) {
                navigator.permissions
                    .query({ name: 'geolocation' })
                    .then((permissionStatus) => {
                        // Only when already granted: the distance badge is a
                        // nicety and must not raise the browser's permission
                        // prompt on page load (Lighthouse Best Practices).
                        // Users grant location from the search bar instead.
                        if (permissionStatus.state === 'granted') {
                            navigator.geolocation.getCurrentPosition(
                                ({ coords }) => {
                                    const { latitude, longitude } = coords;
                                    resolve({
                                        userLat: latitude,
                                        userLon: longitude
                                    });
                                },
                                () => {
                                    reject();
                                }
                            );
                        } else {
                            reject();
                        }
                    });
            } else {
                reject();
            }
        });
    }

    calculateDistance(
        lat1: number,
        lon1: number,
        lat2: number,
        lon2: number
    ): number {
        const p: number = 0.017453292519943295;
        const c = Math.cos;
        const a: number =
            0.5 -
            c((lat2 - lat1) * p) / 2 +
            (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
        return 12742 * Math.asin(Math.sqrt(a));
    }
}
